export default [
    {
        path: 'atendimento-odontologico',
        component: () => import(
            '@/views/atencao-basica/atendimento-odontologico/Index'
        ),
        redirect: 'atendimento-odontologico/index',
        children: [
            {
                name: 'atencao-basica-atendimento-odontologico',
                path: 'index',
                props: true,
                component: () => import(
                    '@/views/atencao-basica/atendimento-odontologico/List'
                ),
            },
            {
                name: 'atencao-basica-atendimento-odontologico-create',
                path: 'create/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    '@/views/atencao-basica/atendimento-odontologico/Form'
                )
            },
            {
                name: 'atencao-basica-atendimento-odontologico-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    '@/views/atencao-basica/atendimento-odontologico/Edit'
                )
            },
        ],
    },
]